<template>
    <div>
        <Card>
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">类别管理</span>
                    </div>
                    <div class="right-bar" />
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="12">
                <Card>
                    <div slot="title"
                        class="title">
                        <div class="text">大类管理</div>
                        <div class="action">
                            <Button v-if="$checkAccessArray(['S'])"
                                size="small"
                                type="primary"
                                @click="onCreateMain">新增
                            </Button>
                        </div>
                    </div>
                    <Row :gutter="16">
                        <Col span="24">
                        <Table ref="mainTable"
                            :columns="main.columns"
                            :data="main.rows"
                            :height="tableHeight"
                            highlight-row
                            stripe
                            border
                            size="small"
                            :loading="main.loading" />
                        </Col>
                    </Row>
                </Card>
                </Col>

                <Col span="12">
                <Card>
                    <div slot="title"
                        class="title">
                        <div class="text">小类管理</div>
                        <div v-if="currentMainCategoryUuid !== ''"
                            class="search">
                            <Input v-model="subCategorySearch.subCategoryName"
                                size="small"
                                placeholder="名称"
                                style="width: 150px; margin-right: 5px;"></Input>
                            <Input v-model="subCategorySearch.masterName"
                                size="small"
                                placeholder="专家"
                                style="width: 150px; margin-right: 5px;"></Input>
                            <Button type="info"
                                size="small"
                                @click="onSubCategorySearch()">搜索</Button>
                            <Button type="default"
                                size="small"
                                style="margin-left:10px;"
                                @click="onSubCategorySearchReset()">重置</Button>
                        </div>

                        <div class="action">
                            <Button v-if="$checkAccessArray(['S'])"
                                size="small"
                                type="primary"
                                @click="onCreateSub">新增
                            </Button>
                        </div>
                    </div>

                    <Row :gutter="16">
                        <Col span="24">
                        <Table ref="subTable"
                            :columns="sub.columns"
                            :data="sub.rows"
                            :height="tableHeight"
                            highlight-row
                            stripe
                            size="small"
                            :loading="sub.loading"
                            border />
                        </Col>
                    </Row>
                </Card>
                </Col>
            </Row>
        </Card>

        <Modal v-model="sub.formShow"
            title="小类信息"
            @on-ok="onSaveSub()"
            @on-cancel=" sub.formShow = false">
            <Form ref="subForm"
                :model="sub.form"
                label-position="top">
                <Row :gutter="16">
                    <Col span="8">
                    <FormItem label="名称">
                        <Input v-model="sub.form.subCategoryName"></Input>
                    </FormItem>
                    </Col>
                    <!-- <Col span="8">
                    <FormItem label="代码">
                        <Input v-model="sub.form.subCategoryCode"></Input>
                    </FormItem>
                    </Col> -->
                    <Col span="8">
                    <FormItem label="品牌">
                        <Input v-model="sub.form.brand"></Input>
                    </FormItem>
                    </Col>
					<Col span="8">
					<FormItem label="前台显示">
					    <Select v-model="sub.form.subCategoryFrontend"
					        filterable>
					        <Option v-for="item in frontendShowSource"
					            :key="item.value"
					            :value="item.value">{{ item.label }}</Option>
					    </Select>
					</FormItem>
					</Col>
                </Row>
                <Row :gutter="16">
                    <Col span="8">
                    <FormItem label="顺序">
                        <integer-input v-model="sub.form.subCategoryOrder" />
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="专家">
                        <Select v-model="sub.form.subCategoryRelateMasterLoginUuid"
                            filterable>
                            <Option v-for="item in masterUserSource"
                                :key="item.userMasterLoginUuid"
                                :value="item.userMasterLoginUuid">{{ item.userMasterName }}</Option>
                        </Select>
                    </FormItem>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <Col span="6">
                    <FormItem label="图片">
                        <single-file-upload-with-name v-model="sub.form.subCategoryFile" />
                    </FormItem>
                    </Col>
                </Row>
            </Form>
        </Modal>

        <Modal v-model="main.formShow"
            title="大类信息"
            @on-ok="onSaveMain()"
            @on-cancel=" main.formShow = false">
            <Form ref="mainForm"
                :model="main.form"
                label-position="top">
                <Row :gutter="16">
                    <Col span="8">
                    <FormItem label="名称">
                        <Input v-model="main.form.mainCategoryName"></Input>
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="代码">
                        <Input v-model="main.form.mainCategoryCode"></Input>
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="拉丁文">
                        <Input v-model="main.form.mainCategoryLatin"></Input>
                    </FormItem>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <Col span="8">
                    <FormItem label="顺序">
                        <integer-input v-model="main.form.mainCategoryOrder" />
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="前台显示">
                        <Select v-model="main.form.mainCategoryFrontend"
                            filterable>
                            <Option v-for="item in frontendShowSource"
                                :key="item.value"
                                :value="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <Col span="8">
                    <FormItem label="图片">
                        <single-file-upload-with-name v-model="main.form.mainCategoryFile" />
                    </FormItem>
                    </Col>
                </Row>
            </Form>
        </Modal>
    </div>
</template>

<script>
import search from '@/libs/search';
import { FRONTEND_HIDE, FRONTEND_SHOW, frontendFormat } from '@/libs/baseModelFormat';
import IntegerInput from '@/components/number-input/integer-input';
import SingleFileUploadWithName from '@/components/single-file-upload-with-name/SingleFileUploadWithName';
import { FORM_EDIT_MODE_CREATE, FORM_EDIT_MODE_MODIFY } from '@/view/mixins/form-edit-mode';
import { singleImageRender } from '@/libs/tableRowImageRender';

import {
    getMainCategoryList,
    getSubCategoryList,
    pageInit4CategoryList,
    saveMainCategory,
    saveSubCategory
} from '@/api/modules/product-management/category-management';

export default {
    name: 'CategoryList',
    components: {
        IntegerInput,
        SingleFileUploadWithName
    },
    data() {
        return {
            main: {
                columns: [
                    { title: '名称', key: 'mainCategoryName', align: 'center' },
                    { title: '代码', key: 'mainCategoryCode', align: 'center' },
                    // { title: '拉丁文', key: 'mainCategoryLatin', align: 'center' },
                    { title: '图片', align: 'center', render: (h, params) => singleImageRender(h, params.row.mainCategoryFile) },
                    {
                        title: '前台显示',
                        key: 'mainCategoryFrontend',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {}, frontendFormat(params.row.mainCategoryFrontend))
                            ]);
                        }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style: {},
                                    on: {
                                        click: () => {
                                            this.onEditMain(params.row);
                                        }
                                    }
                                }, '编辑'),
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style: {},
                                    on: {
                                        click: () => {
                                            this.onMainRowChange(params.row);
                                        }
                                    }
                                }, '查看小类')]);
                        }
                    }
                ],
                rows: [],
                form: {
                    formEditMode: '',
                    mainCategoryUuid: '',
                    mainCategoryName: '',
                    mainCategoryCode: '',
                    mainCategoryLatin: '',
                    mainCategoryFile: '',
                    mainCategoryOrder: 1000,
                    mainCategoryFrontend: FRONTEND_SHOW
                },
                formShow: false,
                loading: false
            },
            sub: {
                columns: [
                    { title: '名称', key: 'subCategoryName', align: 'center' },
                    // { title: '代码', key: 'subCategoryCode', align: 'center' },
                    { title: '品牌', key: 'brand', align: 'center' },
                    { title: '专家', key: 'userMasterName', align: 'center' },
                    { title: '图片', align: 'center', render: (h, params) => singleImageRender(h, params.row.subCategoryFile) },
                    {
                        title: '前台显示',
                        key: 'subCategoryFrontend',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {}, frontendFormat(params.row.subCategoryFrontend))
                            ]);
                        }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style: {},
                                    on: {
                                        click: () => {
                                            this.onEditSub(params.row);
                                        }
                                    }
                                }, '编辑')]);
                        }
                    }
                ],
                rows: [],
                form: {
                    formEditMode: '',
                    subCategoryUuid: '',
                    subCategoryMainUuid: '',
                    subCategoryName: '',
                    // subCategoryCode: '',
                    subCategoryFile: '',
                    subCategoryOrder: 1000,
                    subCategoryFrontend: FRONTEND_SHOW,
                    subCategoryRelateMasterLoginUuid: '',
                    brand: ''
                },
                formShow: false,
                loading: false
            },
            frontendShowSource: [],
            masterUserSource: [],
            subCategorySearch: {
                subCategoryName: '',
                masterName: ''
            },
            currentMainCategoryUuid: '',
            tableHeight: 300
        };
    },
    beforeRouteLeave(to, from, next) {
        this.main.rows = [];
        this.sub.rows = [];
        this.$destroy();
        next();
    },
    mounted() {
        this.tableHeight
            = window.innerHeight
            - this.$refs.mainTable.$el.offsetTop
            - 260;
        this.init();
    },
    methods: {
        init() {
            this.frontendShowSource = [];
            this.frontendShowSource.push({ label: frontendFormat(FRONTEND_SHOW), value: FRONTEND_SHOW });
            this.frontendShowSource.push({ label: frontendFormat(FRONTEND_HIDE), value: FRONTEND_HIDE });

            pageInit4CategoryList().then(res => {
                if (res.code === 0) {
                    this.masterUserSource = res.data.master.records.map(item => {
                        return {
                            userMasterLoginUuid: item.userMasterLoginUuid,
                            userMasterName: item.userMasterName
                        };
                    });
                    this.getMainCategory();
                }
            });
        },
        getMainCategory() {
            const mainSearch = search.getSearchParams({ closeAllConditions: true });
            this.main.loading = true;
            getMainCategoryList(mainSearch).then(res => {
                this.main.loading = false;
                if (res.code === 0) {
                    this.main.rows = res.data.records;
                }
            });
        },
        getSubCategory(mainCategoryUuid) {
            this.sub.form.subCategoryMainUuid = mainCategoryUuid;

            const subSearch = search.getSearchParams({ closeAllConditions: true });
            subSearch.filters.enable = true;
            subSearch.filters.conditions.push({ name: 'subCategoryMainUuid', type: 'eq', value: mainCategoryUuid });

            if (this.subCategorySearch.subCategoryName !== '') {
                subSearch.filters.conditions.push({ name: 'subCategoryName', type: 'like', value: this.subCategorySearch.subCategoryName });
            }

            if (this.subCategorySearch.masterName !== '') {
                subSearch.filters.conditions.push({ name: 'userMasterName', type: 'like', value: this.subCategorySearch.masterName });
            }

            this.sub.loading = true;
            getSubCategoryList(subSearch).then(res => {
                this.sub.loading = false;
                if (res.code === 0) {
                    this.sub.rows = res.data.records;
                }
            });
        },
        onMainRowChange(currentRow) {
            this.currentMainCategoryUuid = currentRow.mainCategoryUuid;

            this.subCategorySearch.masterName = '';
            this.subCategorySearch.subCategoryName = '';

            this.getSubCategory(this.currentMainCategoryUuid);
        },
        onCreateMain() {
            this.main.form.formEditMode = FORM_EDIT_MODE_CREATE;
            this.main.form.mainCategoryUuid = '';
            this.main.form.mainCategoryName = '';
            this.main.form.mainCategoryCode = '';
            this.main.form.mainCategoryLatin = '';
            this.main.form.mainCategoryFile = '';
            this.main.form.mainCategoryOrder = 1000;
            this.main.form.mainCategoryFrontend = FRONTEND_SHOW;

            this.main.formShow = true;
        },
        onEditMain(row) {
            this.main.form.formEditMode = FORM_EDIT_MODE_MODIFY;
            this.main.form.mainCategoryUuid = row.mainCategoryUuid;
            this.main.form.mainCategoryName = row.mainCategoryName;
            this.main.form.mainCategoryCode = row.mainCategoryCode;
            this.main.form.mainCategoryLatin = row.mainCategoryLatin;
            this.main.form.mainCategoryFile = row.mainCategoryFile;
            this.main.form.mainCategoryOrder = row.mainCategoryOrder;
            this.main.form.mainCategoryFrontend = row.mainCategoryFrontend;

            this.main.formShow = true;
        },
        onSaveMain() {
            const data = Object.assign({}, this.main.form);
            saveMainCategory(data).then(res => {
                if (res.code === 0) {
                    this.init();
                    // this.$Modal.success({
                    //     title: '保存成功',
                    //     onOk: () => {
                    //         window.location.reload();
                    //     }
                    // });
                }
            });
        },
        onEditSub(row) {
            this.sub.form.formEditMode = FORM_EDIT_MODE_MODIFY;
            this.sub.form.subCategoryUuid = row.subCategoryUuid;
            this.sub.form.subCategoryName = row.subCategoryName;
            // this.sub.form.subCategoryCode = row.subCategoryCode;
            this.sub.form.subCategoryFile = row.subCategoryFile;
            this.sub.form.subCategoryOrder = row.subCategoryOrder;
            this.sub.form.subCategoryFrontend = row.subCategoryFrontend;
            this.sub.form.subCategoryRelateMasterLoginUuid = row.subCategoryRelateMasterLoginUuid;
            this.sub.form.brand = row.brand;

            this.sub.formShow = true;
        },
        onCreateSub() {
            if (!this.sub.form.subCategoryMainUuid) {
                this.$Message.error('请先选择大类');
                return;
            }

            this.sub.form.formEditMode = FORM_EDIT_MODE_CREATE;
            this.sub.form.subCategoryUuid = '';
            this.sub.form.subCategoryName = '';
            // this.sub.form.subCategoryCode = '';
            this.sub.form.subCategoryFile = '';
            this.sub.form.subCategoryOrder = 1000;
            this.sub.form.subCategoryFrontend = FRONTEND_SHOW;
            this.sub.form.subCategoryRelateMasterLoginUuid = '';
            this.sub.form.brand = '';

            this.sub.formShow = true;
        },
        onSaveSub() {
            const data = Object.assign({}, this.sub.form);
            saveSubCategory(data).then(res => {
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '保存成功',
                        onOk: () => {
                            // window.location.reload();
                            this.sub.formShow = false;
                            this.getSubCategory(this.currentMainCategoryUuid);
                        }
                    });
                }
            });
        },
        onSubCategorySearch() {
            this.getSubCategory(this.currentMainCategoryUuid);
        },
        onSubCategorySearchReset() {
            this.subCategorySearch.masterName = '';
            this.subCategorySearch.subCategoryName = '';
            this.getSubCategory(this.currentMainCategoryUuid);
        }
    }
};
</script>

<style scoped lang="less">
@titleHeight: 25px;

.border {
    border: 1px solid #c9c9c9;
    margin-bottom: 5px;
    padding: 5px 5px 5px 5px;
}

.title {
    height: @titleHeight;

    .text {
        font-weight: bold;
        float: left;
        line-height: @titleHeight;
    }

    .search {
        float: left;
        margin-left: 20px;
    }

    .action {
        float: right;
    }
}
</style>
